<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 11:15:13
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-17 19:41:26
-->
<template>
  <div class="comp-question">
    <el-form
      ref="compForm"
      :model="questionInfo"
      :rules="rules"
      label-width="100px"
      class="compForm"
    >
      <el-form-item label="题干:" prop="questionName">
        <tinymce
          ref="editor"
          v-model="questionInfo.questionName"
          height="170"
          width="783"
        ></tinymce>
      </el-form-item>
      <el-form-item label="标准答案:" prop="rightOption">
        <el-button
          v-show="questionInfo.optionList.length < tagList.length"
          class="addBtn"
          icon="el-icon-circle-plus-outline"
          @click="addOption"
        >
          增加答案
        </el-button>
        <div v-show="questionInfo.optionList.length == tagList.length" style="color:#fff">--</div>
        <div class="option-list">
          <div v-for="(item, index) in questionInfo.optionList" :key="item.id" class="option-item">
            <div class="label">填空{{ index + 1 }}：</div>
            <tinymce ref="editor" v-model="item.optionName" height="120" width="713"></tinymce>
            <i
              v-show="questionInfo.optionList.length > 1"
              class="el-icon-delete"
              @click="removeOption(index)"
            ></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="解析:" prop="analysis">
        <tinymce key="com" v-model="questionInfo.analysis" height="170" width="783"></tinymce>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button :loading="loading" type="primary" @click="save">保存</el-button>
      <el-button @click="remove">删除</el-button>
    </div>
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce'
let newOptionId = 1
export default {
  name: 'JudgeQuestion',
  components: { Tinymce },
  props: {
    questionInfo: {
      type: Object,
      default: () => ({
        optionList: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagList: ['a', 'b', 'c', 'd', 'e', 'f', 'g'],
      rules: {
        questionName: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        rightOption: [{ required: true, message: '请输入答案', trigger: 'change' }],
      },
    }
  },
  methods: {
    addOption() {
      if (this.questionInfo.optionList.length >= this.tagList.length) return
      this.questionInfo.optionList.push({
        id: 'new' + newOptionId,
        optionName: '',
      })
      newOptionId++
    },
    removeOption(index) {
      this.questionInfo.optionList.splice(index, 1)
    },
    save() {
      const { questionName, questionType, score, optionList, analysis } = this.questionInfo
      let optionObj = {}
      let rightKeyArr = []
      optionList.map((item, index) => {
        this.$set(optionObj, this.tagList[index], item.optionName)
        rightKeyArr.push(index + 1)
      })
      let params = {
        questionName,
        questionType,
        score,
        analysis,
        ...optionObj,
        rightKey: rightKeyArr.join(','),
      }
      this.$emit('edit', params)
    },
    remove() {
      this.$emit('remove')
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-form {
  .tox-tinymce {
    width: 820px;
  }
  .el-form-item__label {
    height: 36px;
    line-height: 36px;
  }
  .addBtn {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    i {
      font-size: 16px;
    }
  }
  .option-list {
    margin-left: -70px;
  }
  .option-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .label {
      font-size: 16px;
      font-weight: 400;
      color: #4d4d4d;
      white-space: nowrap;
      margin-right: 10px;
    }
    > i {
      cursor: pointer;
      font-size: 16px;
      color: #3671bf;
      margin-left: 20px;
    }
  }
}
</style>
